const APP_STORE_URL = 'https://apps.apple.com/pk/app/quit-gooning/id6758883662';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.extendztech.quit_gooning&pcampaignid=web_share';

export default function StoreButtons() {
  return (
    <div className="store-buttons">
      <a
        href={APP_STORE_URL}
        className="store-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download on the App Store"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 16.99 2.97 12.5 4.7 9.56C5.55 8.08 7.13 7.16 8.82 7.14C10.1 7.12 11.32 8.01 12.11 8.01C12.89 8.01 14.37 6.94 15.92 7.11C16.57 7.14 18.39 7.38 19.56 9.07C19.47 9.13 17.29 10.39 17.31 13.01C17.34 16.15 20.07 17.18 20.1 17.19C20.07 17.26 19.67 18.64 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" fill="white"/>
        </svg>
        <div className="store-btn-text">
          <span className="store-btn-small">Download on the</span>
          <span className="store-btn-large">App Store</span>
        </div>
      </a>
      <a
        href={PLAY_STORE_URL}
        className="store-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get it on Google Play"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M3.61 1.814L13.793 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.61-.92zM14.5 12.707l2.55 2.55-8.97 5.1 6.42-7.65zM17.256 8.743L14.5 11.293l-6.42-7.65 8.97 5.1h.206zM20.16 10.95c.58.34.84.87.84 1.05s-.26.71-.84 1.05l-2.16 1.23-2.79-2.28 2.79-2.28 2.16 1.23z" fill="white"/>
        </svg>
        <div className="store-btn-text">
          <span className="store-btn-small">Get it on</span>
          <span className="store-btn-large">Google Play</span>
        </div>
      </a>
    </div>
  );
}
